import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

/**
 * The personal start page. It is the landing route of the main layout, so it lives at
 * the layout's empty path. Guards are attached in `routeMainLayout.ts` - keeping this
 * module free of store imports avoids a cycle with the sidebar map.
 */
const routeHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/home/HomeView.vue')
  },
  name: 'home-page',
  path: '',
}

export { routeHome }
